<span class="fas fa-circle"
      [ngClass]="ratingClass"></span>
<label *ngIf="showText"
       class="ms-1">{{ratingText}}</label>
